import {createAction, PayloadAction} from '@reduxjs/toolkit';
import {put, call, ForkEffect, takeEvery} from 'redux-saga/effects';

import * as log from '../../../../../logger';
import {fetchFullProjects} from '../lightProjectsApi';
import {fail, loadFullProjects} from '../lightProjectsSlice';
import {TFullProject, TFullProjects} from '../lightProjectsTypes';

type TLoadFullProjectsPayload = {
  hash_list: string[];
};

export const requestLoadFullProjects = createAction<TLoadFullProjectsPayload>(
  'lightProjects/requestLoadFullProjects',
);

function* requestLoadFullProjectsSaga({
  payload,
}: PayloadAction<TLoadFullProjectsPayload>) {
  try {
    const fullProjectsList: TFullProject[] = yield call(
      fetchFullProjects,
      payload.hash_list,
    );

    const fullProjects: TFullProjects = {};

    for (const fullProject of fullProjectsList) {
      fullProjects[fullProject.hash] = fullProject;
    }

    yield put(loadFullProjects({fullProjects}));
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail({error: 'requestLoadLightProjectsError'}));
  }
}

function* watchRequestLoadFullProjects(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield takeEvery(requestLoadFullProjects.type, requestLoadFullProjectsSaga);
}

export default watchRequestLoadFullProjects;
